import { Component } from 'react';
import { connect } from 'react-redux';
import { RootState } from "app/redux/reducer";
import { bindActionCreators, Dispatch } from 'redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { TextField, PrimaryButton, Dropdown, DefaultButton, Checkbox, Label } from 'office-ui-fabric-react';

import { deleteActivity, getActivities, IActivity,toogleFeaturedActivity, getFeaturedActivities } from 'app/services/activity';
import { publishActivityVariantByActivity } from 'app/services/activity-variant';
import { IList, IListFilter, IListState, StatusEnum } from 'app/shared';
import PageLayout from 'containers/PageLayout';

import PageTitle from 'components/customs/PageTitle';
import BasicTable from 'components/customs/BasicTable';
import { castThunkAction } from 'app/utils/casting';
import { showMessage, toggleConfirmDialog } from 'app/redux/system/actions';
import clsx from 'clsx';
import ArctivityTypeSelector from 'components/customs/ActivityTypesSelector/ArctivityTypeSelector';

function mapStateToProps(state: RootState, ownProps: RouteComponentProps) {
    return {
        ...ownProps,
        language: state.system.language,
        pageData: state.page.pageData as IList<IActivity[]>,
        defaultLanguage: state.system.defaultLanguage
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return bindActionCreators({
        deleteActivity,
        getActivities,
        toggleConfirmDialog,
        publishActivityVariantByActivity,
        getFeaturedActivities,
        showMessage,
        toogleFeaturedActivity
    }, dispatch);
}

type IProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class FeaturedActivities extends Component<IProps, IListState> {

    state = {
        type: "activity",
        filterObject: {
            title: "",
            status: 1,
            isWebPublish: undefined,
            createdOn: "",
            activityTypeIds: "",
            language: this.props.defaultLanguage,
            isFeatured: false
        },
        pagerObject: {
            page: 1,
            descending: false,
            pageSize: 10
        },
        activeStatus: StatusEnum.Published
    }

    componentDidMount() {
        window.addEventListener("keydown", this.onEnterSearch, true);
        this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onEnterSearch, true);
    }

    onEnterSearch = (e: any) => {
        if (e.key === "Enter") {
            this.searchList();
        }
    };

    makeRequest(options: IListFilter) {
      

      if (this.state.filterObject.isFeatured) {
            castThunkAction(this.props.getFeaturedActivities(options))
                .then(() => {
                    this.setState({
                        activeStatus: StatusEnum.Deleted,
                    })
                })
        } else {
            castThunkAction(this.props.getActivities(options)).then(() => {
                this.setState({
                    activeStatus: this.state.filterObject.status,
                })
            })
        }
    }

    searchList() {
        this.setState({
            pagerObject: {
                page: 1,
                descending: false,
                pageSize: 10
            },
        }, () => {
            this.makeRequest({
                ...this.state.pagerObject,
                ...this.state.filterObject
            })
        })
    }

    renderFilter() {
        return (
            <div className="table-filter row">
                <TextField
                    className="custom-textfield col-md-2"
                    label="Başlık İle Arama"
                    value={this.state.filterObject?.title || ""}
                    onChange={(event: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "title": event.target.value
                            }
                        })
                    }}
                />
                <Dropdown
                    options={[
                        { key: 'all', text: "Tümü" },
                        { key: 'true', text: "Web'de gösterilsin" },
                        { key: 'false', text: "Web'de gösterilmesin" }
                    ]}
                    className="custom-dropdown col-md-2"
                    label="Gösterim Durumuna Göre Arama"
                    placeholder="Seçiniz"
                    selectedKey={typeof this.state.filterObject?.isWebPublish === "undefined" ?
                        "all" : this.state.filterObject.isWebPublish}
                    onChange={(event: any, option: any) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                "isWebPublish": option?.key === "all" ? undefined : option?.key
                            }
                        })
                    }}
                    calloutProps={{
                        className: "custom-dropdown-callout"
                    }}
                />
                <div className="col-md-2">
                    <Label>
                        Sadece Öne çıkanları göster
                    </Label>
                    <Checkbox  className='col-md-2' checked={this.state.filterObject?.isFeatured} onChange={(event: any, checked?: boolean) => {
                        this.setState({
                            filterObject: {
                                ...this.state.filterObject,
                                isFeatured: checked === true
                            }
                        })
                    }} />
                </div>
                <ArctivityTypeSelector 
                  onChange={(val)=>{
                    this.setState({
                      filterObject: {
                        ...this.state.filterObject,
                        activityTypeIds: val,
                      },
                    });
                  }}
                  className='custom-combobox col-md-2'
                  value={this.state.filterObject.activityTypeIds}
                />
                <PrimaryButton
                    text="Arama Yap"
                    className="custom-button"
                    onClick={() => this.makeRequest({ ...this.state.pagerObject, ...this.state.filterObject })}
                    styles={{
                        root: {
                            fontSize: "11px",
                            marginTop: "27px",
                            height: "37px"
                        }
                    }}
                />
            </div>
        )
    }

    renderList() {
        return (
            <BasicTable
                totalCount={this.props.pageData.totalCount}
                columns={[
                    {
                        columnName: "adminTitle",
                        text: "Etkinlik Adı",
                        col: "col-md-3",
                        onRender: (item: IActivity) => {
                            return (
                                <Link to={`/activity/edit/${item.id}`}>
                                    {item.adminTitle || item.title}
                                </Link>
                            )
                        }
                    },
                    {
                        columnName: "key",
                        text: "Etkinlik Anahtarı",
                        col: "col-md-3"
                    },
                    {
                        columnName: "isWebPublish",
                        text: "Web'de Gösterim",
                        col: "col-md-2",
                        onRender: (item: IActivity) => {
                            if (item.isWebPublish) {
                                return <span className="td-button" style={{ background: "#2b925f" }}>Gösterimde</span>
                            } return <span className="td-button" style={{ background: "#ede0d6", color: "#a74d09" }}>Gizli</span>
                        }
                    },
                    {
                      columnName: "isFeaturedActivity",
                      text: "Öne Çıkan Etkinlik",
                      col: "col-md-2",
                      onRender: (item: IActivity) => {
                        return (
                          <DefaultButton
                            onClick={() =>
                              castThunkAction(this.props.toogleFeaturedActivity(
                                item.id as string,
                                item.isFeaturedActivity as boolean,
                                item.key,
                                this.props.defaultLanguage
                              )).then(() => {
                                this.makeRequest({
                                  ...this.state.pagerObject,
                                  ...this.state.filterObject,
                                });
                              })
                            }
                            className={clsx(
                              'td-button custom-button',
                              item.isFeaturedActivity
                                ? 'custom-button-green'
                                : 'custom-button-yellow'
                            )}
                            style={{ width: '100%' }}
                            children={
                              item.isFeaturedActivity
                                ? 'Öne Çıkarıldı'
                                : 'Öne Çıkar'
                            }
                          />
                        );
                      }
                    },
                ]}
                items={this.props.pageData.list}
                showPager={true}
                pageCount={this.props.pageData.pageCount}
                onChangePageSize={(pageSize) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, pageSize } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        pageSize
                    }))
                }}
                onChangePager={(pageNumber) => {
                    this.setState({ pagerObject: { ...this.state.pagerObject, page: pageNumber } }, () => this.makeRequest({
                        ...this.state.pagerObject,
                        ...this.state.filterObject,
                        page: pageNumber
                    }))
                }}
                pageIndex={this.state.pagerObject.page - 1}
            />
        )
    }

    render() {
        return (
            <PageLayout history={this.props.history} match={this.props.match} location={this.props.location}>
                <div className="page push-all">
                    <PageTitle
                        title="Öne Çıkan Etkinlikler"
                        subTitle="Öne çıkan etkinliklerinizi bu sayfadan yönetebilirsiniz."
                        backUrl="/"
                        showBack
                        history={this.props.history}
                    />
                    {this.renderFilter()}
                    {this.renderList()}
                </div>
            </PageLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedActivities);